export default __webpack_public_path__ + "static/media/web.37bc230a.jpg";